<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const baseTitle = '学芸員の求人・募集'
const headTitle = baseTitle

const app = useNuxtApp()
const route = useRoute()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const pageData = {
  items: [] as Article[],
  meta: {} as ApiMeta,
}

const refData = {
  isEmptyResult: false,
  pageSize: 20,
  modelPageNo: 1,
  pageCount: 1,
  modelSort: null,
  sortItems: [],
  loading: false,
}

const sortInfo = storeArticleList.getPageSortInfo(props.kjdsPageConfig)
const modelSort = ref(sortInfo?.defaultValue || 'open_date')
if (route.query.sort) {
  modelSort.value = route.query.sort as string
}

const setHead = () => {
  let headDescription = ''
  let items = []
  headDescription = `学芸員やミュージアムスタッフなどの求人・求職・募集情報ページ。美術館や博物館などミュージアムで働きたい方は必見です。求人の情報投稿も募集中。毎日更新中。学芸員の求人・求職ならアイエムで！`
  items = [
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/gakugeiin' },
    },
  ]
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const PAGE_SIZE = 20

const initPage = async () => {
  const currentPage = Number(route.query.page) || 1
  const options: KjdsFetchListOptions = {
    query: {
      ...route.query,
      page: 1,
    },
  }
  const [_resSite, _resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName,
      options),
  ])
  const allItems = resList.data.articles as Article[]
  const totalCount = allItems.length
  pageData.items = allItems.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
  pageData.meta = {
    ...resList.meta,
    page_no: currentPage,
    total_page: Math.ceil(totalCount / PAGE_SIZE),
    count: totalCount,
  }
}

await initPage()
setHead()

const onChangeSort = (val) => {
  modelSort.value = val
  const query = { ...route.query }
  delete query.page
  if (val) {
    query.sort = val
  } else {
    delete query.sort
  }
  navigateTo({
    path: route.path,
    query,
  })
}
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      学芸員の求人・募集
    </h2>

    <div
      class="c-link"
    >
      <nuxt-link
        class="c-link_btn c-link_btn_first"
        to="/static/98639"
      >
        <div class="c-link_btn_text">
          「学芸員募集」コーナーについて
        </div>
      </nuxt-link>
      <a
        class="c-link_btn"
        href="/static/gakugeiin_information"
      >
        <div class="c-link_btn_text">
          情報を投稿する
        </div>
      </a>
    </div>

    <div class="p-articlePage_search">
      <GakugeiinSearchPanel
        v-bind:query="route.query"
        v-bind:loading="refData.loading"
      />
    </div>

    <div class="p-articlePage_result">
      <div
        class="c-listHeader"
      >
        <div class="c-listHeader_col">
          <div class="c-listHeader_col_contentSearch">
            全 {{ app.$anyToComma(pageData.meta.count) }}件
          </div>
        </div>
        <div class="c-listHeader_dropDown">
          <v-select
            v-model="modelSort"
            class="IMCustomOverflowButton marginLeft c-searchSort"
            v-bind:items="sortInfo.items"
            hide-details
            variant="outlined"
            density="comfortable"
            v-on:update:model-value="onChangeSort"
          />
        </div>
      </div>

      <template
        v-if="pageData.meta.count === 0"
      >
        <div class="p-articlePage_empty">
          お探しの情報は見つかりませんでした
        </div>
      </template>

      <div class="p-articlePage_list">
        <template
          v-for="item in pageData.items"
          v-bind:key="item.id"
        >
          <GakugeiinItem
            v-bind:item="item"
          />
        </template>
      </div>

      <template
        v-if="pageData.items?.length"
      >
        <Pagination
          v-bind:page="pageData.meta.page_no"
          v-bind:length="pageData.meta.total_page"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-articlePage {
  &_search {
    margin-bottom: 35px;
  }
}

.c-link {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;

  @include responsive.mq_down(sp) {
    flex-wrap: wrap;
    justify-content: center;
  }

  &_btn {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 48%;
    height: 45px;
    margin: 0;
    transition: 300ms;
    border: 1px solid var(--g_color_table_border_gray);
    text-decoration: none;

    @include responsive.mq_down(sp) {
      width: 100%;
    }

    &_first {
      @include responsive.mq_down(sp) {
        margin-bottom: 12px;
      }
    }

    &:hover {
      opacity: 0.7;
    }

    &_text {
      color: var(--color_text_base);
      font-size: 15px;
      font-weight: bold;
      line-height: 2.286;
    }
  }
}
</style>
